import { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { SubDepartmentColumns } from "../../../SourceData";
import Delete from "./../../../assets/delete.svg";
import Edit from "./../../../assets/edit-user.svg";
import api from "../../../utils/api";
import { message } from "antd";
import usePermissions from "../../../hooks/usePermissions";

const SubDepartments = forwardRef(({ query, onEdit, onDelete }, ref) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const { hasPermission } = usePermissions();

  const getData = async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams({
        page: page + 1, // Convert from 0-based to 1-based pagination
        limit: pageSize, // Changed from per_page to limit to match your API
        type: "shop",
        flag: 2,
      });

      if (query.length >= 2) {
        params.append("search", query);
      }

      const res = await api.get(`/categories?${params.toString()}`);

      // Handle the response structure you provided
      if (res.data.status === "success") {
        setData(res.data.data || []);
        setTotalRows(res.data.total || 0);
      } else {
        // Handle error case
        setData([]);
        setTotalRows(0);
        message.error("فشل في تحميل البيانات");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setData([]);
      setTotalRows(0);
      message.error("حدث خطأ أثناء تحميل البيانات");
    } finally {
      setLoading(false);
    }
  };

  // Expose getData method to parent component
  useImperativeHandle(ref, () => ({
    getData,
  }));

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (query.length >= 2 || query.length === 0) {
        getData();
      }
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [query, page, pageSize]);

  const actionColumn = [
    {
      field: "action",
      headerName: "",
      width: 100,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="cell-action">
            {hasPermission(137) && (
              <div className="cell-btn" onClick={() => onEdit(params.row)}>
                <img src={Edit} alt="" />
              </div>
            )}
            {hasPermission(138) && (
              <div className="cell-btn" onClick={() => onDelete(params.row)}>
                <img src={Delete} alt="" />
              </div>
            )}
          </div>
        );
      },
    },
  ].filter(Boolean); // Remove falsy values from permissions

  const handlePaginationModelChange = (model) => {
    setPage(model.page);
    setPageSize(model.pageSize);
  };

  return (
    <DataGrid
      sx={{ backgroundColor: "white", width: "100%" }}
      autoHeight={true}
      columns={SubDepartmentColumns.concat(actionColumn)}
      rows={data.map((row, index) => ({
        ...row,
        index: page * pageSize + index + 1,
      }))}
      disableVirtualization
      disableColumnFilter
      disableColumnMenu
      loading={loading}
      paginationMode="server"
      rowCount={totalRows}
      pageSizeOptions={[10, 25, 50]}
      paginationModel={{
        page,
        pageSize,
      }}
      onPaginationModelChange={handlePaginationModelChange}
    />
  );
});

export default SubDepartments;
